import { render, staticRenderFns } from "./MiddleName.vue?vue&type=template&id=e036f83a&scoped=true"
import script from "./MiddleName.vue?vue&type=script&lang=js"
export * from "./MiddleName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e036f83a",
  null
  
)

export default component.exports